import { DependencyList, useMemo, useRef } from "react";
import { ObbAnnotation } from "../../api/Application";
import { useState, useCallback, SetStateAction, Dispatch } from "react";

export function useStateDebug<T>( label: string, initial: T | ( () => T ) ): [T, Dispatch<SetStateAction<T>>] {
    const [value, setValue] = useState<T>( initial );

    const setValueDebug = useCallback( ( action: SetStateAction<T> ) => {
        setValue( prev => {
            const next = action instanceof Function ? action( prev ) : action;
            if( !Object.is( prev, next ) ) {
                console.log( `[useState] ${label} changed`, { prev, next } );
                // console.trace();
            }
            return next;
        } );
    }, [label] );

    return [value, setValueDebug];
}

export function useMemoDebug<T>( label: string, factory: () => T, deps: DependencyList ): T {
    const prevDeps = useRef<DependencyList>();

    return useMemo( () => {
        if( prevDeps.current ) {
            const changed = deps
                .map( ( dep, i ) => ( Object.is( dep, prevDeps.current![i] ) ? null : i ) )
                .filter( i => i !== null );
            console.log( `[useMemo] ${label} recomputed — changed deps:`, changed );
        } else {
            console.log( `[useMemo] ${label} initial` );
        }
        prevDeps.current = deps;
        return factory();
    }, deps );
}

export function modify( obb: ObbAnnotation, h: number, w: number, x: number, y: number, a: number ): ObbAnnotation {
    const tmp: ObbAnnotation = {
        ...obb,
        height: obb.height + h,
        width:  obb.width  + w,
        x:     obb.x       + x,
        y:     obb.y       + y,
        angle: obb.angle   + a
    };
    return tmp;
}